import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'
import _imports_1 from '@/assets/img/apply/img-file-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-b5b78978"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-sendsetting" }
const _hoisted_4 = { class: "p-sendsetting-inner" }
const _hoisted_5 = { class: "p-sendsetting-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-sendsetting-heading-1" }, "配信設定", -1))
const _hoisted_7 = { class: "p-sendsetting-settings" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "AIおすすめ配信", -1))
const _hoisted_9 = { class: "p-sendsetting-settings__checkbox" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求人レコメンドの配信", -1))
const _hoisted_13 = { class: "p-sendsetting-settings__checkbox" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = { class: "l-wrapper_nav" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "p-apply_button-wrap" }
const _hoisted_21 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_22 = { class: "c-modal_content" }
const _hoisted_23 = { class: "js-apply-tab" }
const _hoisted_24 = { class: "p-apply-modal" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_26 = { class: "p-apply-modal_heading" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg js-modal-close-trigger" }, null, -1))

import { getCareerInfoService, updateCareerSettingFlagService } from '@/api/services/trnCareerService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { CareerSettingForm, UpdateSettingResponse } from '@/types/career';
import { onMounted, ref } from 'vue';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendSettingView',
  setup(__props) {

const careerForm = ref<CareerSettingForm>();
const errorMessage = ref<string>('');
const modalRef = ref<HTMLDivElement | null>(null);

function scrollToTop() {
  domHelperUtils.scrollToTop();
}


/**
 * Handles the change of the AI or Recommendation Mail flag setting.
 * Updates the corresponding flag in the form, sends the update to the API,
 * and displays an error modal if an error message is returned.
 *
 * @param type The type of flag to change ('AI' or 'RECOMMEND')
 * @param currentValue The current value of the flag
 */
const handleSettingChange = async (type: string, currentValue: number | undefined) => {
  // Check if form and flag values are defined
  if (careerForm.value && careerForm.value.isSendAutoAIMailFlagMP !== undefined &&
    careerForm.value.isSendAutoRecMailFlagMP !== undefined &&
    currentValue !== undefined) {
    // Update the appropriate flag based on the type
    if (type === 'AI') {
      careerForm.value.isSendAutoAIMailFlagMP = toggleCheckedFlag(currentValue);
    } else {
      careerForm.value.isSendAutoRecMailFlagMP = toggleCheckedFlag(currentValue);
    }

    // Call API to update the flag
    const updateResponse = await updateCareerSettingFlagService(careerForm.value);
    // Set error message if API returns any errors
    if (updateResponse && updateResponse.length > 0) {
      errorMessage.value = getErrorMessageFromResponses(updateResponse);
    }

    // Show error modal if there is an error message
    if (errorMessage.value.length > 0) {
      handleShowModalError(true);
      // Revert the value to its default if an error occurs during the update
      if (type === 'AI') {
        careerForm.value.isSendAutoAIMailFlagMP = toggleCheckedFlag(careerForm.value.isSendAutoAIMailFlagMP);
      } else {
        careerForm.value.isSendAutoRecMailFlagMP = toggleCheckedFlag(careerForm.value.isSendAutoRecMailFlagMP);
      }
    }
  }
};

/**
 * Returns the first matching error message in English based on the error code and type from the response array.
 * If there is no matching error, returns an empty string.
 *
 * @param responses Array of UpdateRecommendResponse objects
 * @returns Error message (empty string if no match found)
 */
const getErrorMessageFromResponses = (responses: UpdateSettingResponse[]): string => {
  for (const res of responses) {
    const fault = res.responseFault;
    if (!fault) continue;

    // Return the error message based on responseId and responseType
    switch (`${fault.responseId}_${fault.responseType}`) {
      case 'N003_CAREER':
        return MYPAGE_CONSTANTS.CAREER_SETTING_FLAGS.N003_CAREER;
      case 'N003_MYPAGE':
        return MYPAGE_CONSTANTS.CAREER_SETTING_FLAGS.N003_MYPAGE;
      case 'E002_CAREER':
        return MYPAGE_CONSTANTS.CAREER_SETTING_FLAGS.E002_CAREER;
      case 'E002_MYPAGE':
        return MYPAGE_CONSTANTS.CAREER_SETTING_FLAGS.E002_MYPAGE;
      default:
        if (fault.responseId === '500') {
          return MYPAGE_CONSTANTS.COMMON_ERROR_MESSAGES.NETWORK_FAILURE;
        }
        if (fault.responseId === '401' || fault.responseId === '403') {
          return MYPAGE_CONSTANTS.COMMON_ERROR_MESSAGES.SESSION_TIMEOUT;
        }
    }
  }
  return '';
};


/**
 * Toggles the checked flag: 
 * If the current value is 1 (checked), returns 0 (unchecked).
 * Otherwise, returns the current value unchanged.
 */
const toggleCheckedFlag = (currentValue: number) => {
  return currentValue === 1 ? 0 : 1;
};

/**
 * Show or hide the modal error dialog.
 * 
 * @param isShow - If true, show the modal; if false, hide it and clear the error message.
 */
const handleShowModalError = (isShow: boolean) => {
  // Check that the modal element reference exists
  if (modalRef.value) {
    if (isShow) {
      // Show the modal by adding the 'is-active' class
      modalRef.value.classList.add('is-active');
    } else {
      // Hide the modal by removing the 'is-active' class
      modalRef.value.classList.remove('is-active');
      // Clear the error message when the modal is hidden
      errorMessage.value = '';
    }
  }
};


/**
 * Fetches careerId and career information when the component is mounted.
 * Initializes the careerForm with the retrieved data.
 */
onMounted(async () => {
    const careerInfo = await getCareerInfoService();
    // If careerInfo is valid, initialize the careerForm
    if (careerInfo) {
      careerForm.value = {
        isSendAutoAIMailFlagMP: careerInfo.isSendAutoAIMailFlagMP ?? 0,
        isSendAutoRecMailFlagMP: careerInfo.isSendAutoRecMailFlagMP ?? 0
      };
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: careerForm.value?.isSendAutoAIMailFlagMP === 1 ? true : false,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (handleSettingChange('AI', careerForm.value?.isSendAutoAIMailFlagMP))),
                    name: ""
                  }, null, 40, _hoisted_10),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("li", null, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: careerForm.value?.isSendAutoRecMailFlagMP === 1 ? true : false,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (handleSettingChange('RECOMMEND', careerForm.value?.isSendAutoRecMailFlagMP))),
                    name: ""
                  }, null, 40, _hoisted_14),
                  _hoisted_15
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        onClick: _withModifiers(scrollToTop, ["prevent"]),
        "aria-label": "ページトップへ戻る"
      }, _hoisted_19, 8, _hoisted_17)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", {
        class: "c-modal js-modal-container",
        ref_key: "modalRef",
        ref: modalRef,
        id: "apply"
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "c-modal_close js-modal-close-trigger",
            type: "button",
            "aria-label": "閉じる",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleShowModalError(false)))
          }),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _hoisted_25,
                  _createElementVNode("p", _hoisted_26, _toDisplayString(errorMessage.value), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "p-apply-modal_button -apply",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleShowModalError(false)))
                  }, "OK")
                ])
              ])
            ])
          ])
        ]),
        _hoisted_27
      ], 512)
    ])
  ]))
}
}

})